import { HTTP } from '../../../http-common';
import { httpError } from '../../../models/httpError';
// import { getField, updateField } from 'vuex-map-fields';
import InstallationCharges from '../../../models/InstallationCharges';

const state = {
  installationCharges: [new InstallationCharges()],
  message: new httpError(),
  services: [],
  servicesItems: [],
};

const getters = {
  installationCharges: (state) => state.installationCharges,
  message: (state) => state.message,
};

const mutations = {
  SET_MESSAGE(state, message) {
    state.message = message;
  },
  GET_INSTALLATION_CHARGES(state, data) {
    state.installationCharges.length = 0;
    state.installationCharges = data;
  },
  UPSERT_INSTALLATION_CHARGES(state, data) {
    state.installationCharges = data;
  },
  DELETE_INSTALLATION_CHARGES(state, index) {
    state.installationCharges.splice(index, 1);
  },
  SET_SERVICES(state, installationCharges) {
    state.services = installationCharges;
  },
  SET_SERVICES_ITEMS(state, installationCharges) {
    state.servicesItems = installationCharges;
  },
};

const actions = {
  async getInstallationCharges({ commit, dispatch }, orderID) {
    try {
      let charges = await HTTP.get('order/GetInstallationCharges/' + orderID);
      commit('GET_INSTALLATION_CHARGES', charges.data);
      dispatch('getInstallationServices');
      dispatch('getInstallationServicesItems');
      return Promise.resolve(charges.data);
    } catch (err) {
      dispatch(
        'setMessage',
        new httpError({
          message: 'Error retrieving charges:' + err,
          httpStatus: 500,
        })
      );
      return Promise.reject(err);
    }
  },
  async upsertInstallationCharge({ commit, dispatch }, payload) {
    try {
      let charges = await HTTP.post(
        `order/UpsertInstallationCharge/${payload.orderID}/${payload.isReporting}`,
        payload.charges
      );
      commit('UPSERT_INSTALLATION_CHARGES', charges);
      dispatch(
        'setMessage',
        new httpError({ message: 'Saved successfully', httpStatus: 200 })
      );
      return Promise.resolve(charges);
    } catch (err) {
      dispatch(
        'setMessage',
        new httpError({
          message: 'Error saving charges:' + err,
          httpStatus: 500,
        })
      );
      return Promise.reject(err);
    }
  },
  async deleteInstallationCharges({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      HTTP.delete('order/DeleteInstallationCharges/' + payload.charge.orderId, {
        data: payload.charge.id,
      })
        .then((res) => {
          if (res) commit('DELETE_INSTALLATION_CHARGES', payload.index);
          resolve(res);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error deleting rows: ' + err.message,
              httpStatus: 500,
            })
          );
          reject(err.message);
        });
    });
  },
  
  async getInstallationServices({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      var response = HTTP.get('Order/GetInstallationCategories/', '');
      response
        .then(function (data) {
          var result = data.data;
          commit('SET_SERVICES', result);
          resolve(result);
          return;
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({ message: 'Error:' + err, httpStatus: 200 })
          );
          reject(err);
        });
    });
  },
  async getInstallationServicesItems({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      var response = HTTP.get('Order/GetInstallationServices/', '');
      response
        .then(function (data) {
          var result = data.data;
          commit('SET_SERVICES_ITEMS', result);
          resolve(result);
          return;
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({ message: 'Error:' + err, httpStatus: 200 })
          );
          reject(err);
        });
    });
  },
  async getRecurringChargeDetails({ dispatch }, payload) {
    try {
      let charges = await HTTP.get(
        `order/GetRecurringChargeDetails/${payload}`
      );
      dispatch(
        'setMessage',
        new httpError({ message: 'Retrieved successfully', httpStatus: 200 })
      );
      return Promise.resolve(charges.data);
    } catch (err) {
      dispatch(
        'setMessage',
        new httpError({
          message: 'Error retrieving charges:' + err,
          httpStatus: 500,
        })
      );
      return Promise.reject(err);
    }
  },
  async addRecurringChargeDetails({ dispatch }, payload) {
    try {
      let charges = await HTTP.post('order/AddRecurringChargeDetails', payload);
      dispatch(
        'setMessage',
        new httpError({ message: 'Saved successfully', httpStatus: 200 })
      );
      return Promise.resolve(charges);
    } catch (err) {
      dispatch(
        'setMessage',
        new httpError({
          message: 'Error saving charges:' + err,
          httpStatus: 500,
        })
      );
      return Promise.reject(err);
    }
  },
  setMessage({ commit }, message) {
    commit('SET_MESSAGE', message);
    if (message.httpStatus !== 500)
      setTimeout(() => {
        commit('SET_MESSAGE', new httpError());
      }, 2000);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
